/* In-page links shared by the navbar and the footer "Navigate" column */
export const NAV_LINKS = [
  { label: "About", href: "/#about" },
  { label: "Services", href: "/#services-stack" },
  { label: "Process", href: "/#process" },
  { label: "Works", href: "/#work" },
  { label: "FAQs", href: "/#faq" },
  { label: "Careers", href: "/careers" },
];

/* Our own products, listed under the navbar's "Products" menu (and in the phone menu).
   every product opens in a new tab; `external` ones leave the site, so they are plain links, not router links. */
export const PRODUCTS = [
  {
    label: "Omni-Channel",
    note: "Five apps, five logins — one inbox.",
    href: "https://omnichannel.version3.ai",
    external: true,
  },
  {
    label: "Agentic AI Support",
    note: "An AI agent that sells, tracks orders, and knows when to stop.",
    href: "/work/version3-ai-support-agent",
  },
];
